angular.module('natura').directive('pggSidebar', [
  'pggConfigProvider',
  'pggLayerTreeProvider',
  'pggEditProvider',
  'pggStyleProvider',
  'pggLayerProvider',
  function (pggConfigProvider, pggLayerTreeProvider, pggEditProvider, pggStyleProvider, pggLayerProvider) {
    return {
      restrict: "E",
      templateUrl: function (tElement, tAttrs) {
        switch (tAttrs.type) {
          case "gazdalkodoi":
            return "assets/terkep/app/sidebar/sidebar_gazdalkodoi.html";
          default:
            return "assets/terkep/app/sidebar/sidebar.html";
        }
      },
      replace: true,
      scope: {
        map: "="
      },
      link: function (scope, element, attrs) {
        switch (attrs.type) {
          case "gazdalkodoi":
            scope.edit = {
              name: "edit",
              title: "Szerkesztés",
              visible: false,
              icon: "assets/terkep/img/icon-edit_30px.png"
            };
            scope.elements.push(scope.edit);

            //kivágott kezelési egységek réteg
            var clipped = pggLayerProvider.createNaturaGeoserverLayer({
              name: "Gazdálkodói tábla kezelési egységei",
              layername: "natura:clipped",
              cql_filter: "userid=" + pggEditProvider.getUserId(),
              isLegendGraphic: true,
              isBaseLayer: false,
              isVisible: false,
              isReloadable: true,
              opacity: 1,
              url: pggConfigProvider.getGeoserverUrl(),
              tiled: true
            });
            pggLayerProvider.addLayerWithZMax(clipped, pggLayerProvider.getNextZMax());

            var editLayer = pggLayerProvider.createNaturaGeoserverWfsLayer({
              displayName: "Gazdálkodói táblák",
              typeName: "natura:agronomist_area_geom_view",
              outputFormat: "text/javascript",
              srsName: pggConfigProvider.getSrs(),
              cqlFilter: "(deleted_at is null and userid=" + pggEditProvider.getUserId(),
              geomColumn: "geom",
              style: pggStyleProvider.getDefaultStyleByFeature,
              legendGraphic: false,
              baseLayer: false
            });
            pggLayerProvider.addLayerWithZMax(editLayer, pggLayerProvider.getNextZMax());
            break;
          default:
            break;
        }
      },

      controller: "PggSidebarController",
      controllerAs: "ctrl",
      bindToController: true
    };
  }
]);

angular.module('natura').controller('PggSidebarController', ['$scope', 'pggInteractionsProvider', 'pggPrintProvider', '$window',
  function ($scope, pggInteractionsProvider, pggPrintProvider, $window) {
    $scope.map = this.map;

    $scope.elements = [];

    $scope.layers = {
      name: "layers",
      title: "Térképi rétegek",
      visible: true,
      icon: "assets/terkep/img/icon-layers_30px.png"
    };
    $scope.elements.push($scope.layers);

    $scope.featureInfo = {
      name: "featureinfo",
      title: "Elem lekérdezés",
      visible: false,
      icon: "assets/terkep/img/icon-info_30px.png"
    };
    $scope.elements.push($scope.featureInfo);

    $scope.print = {
      name: "print",
      title: "Nyomtatás fájlba",
      visible: false,
      icon: "assets/terkep/img/icon-print_30px.png"
    };
    $scope.elements.push($scope.print);

    $scope.measure = {
      name: "measure",
      title: "Mérések",
      visible: false,
      icon: "assets/terkep/img/icon-measure_30px.png"
    };
    $scope.elements.push($scope.measure);

    $scope.sugo = {
      name: "sugo",
      title: "Súgó megjelenítése",
      visible: true,
      icon: "assets/terkep/img/icon-sugo_30px.png"
    };

    this.doOpenSugo = function (url) {
      var dokWindow = $window.open(url, 'Súgó', 'width=' + $window.innerWidth * 0.5 + ', height=' + $window.innerHeight * 0.8 + ', scrollbars=1, resizable=1');
      dokWindow.focus();
    };

    this.openTerkepSugo = function () {
      var url = "assets/terkep/etc/sugo_terkep.pdf";
      this.doOpenSugo(url);
    };

    this.openGazdalkodoiSugo = function () {
      var url = "assets/terkep/etc/sugo_gazdalkodoi.pdf";
      this.doOpenSugo(url);
    };

    this.setVisible = function (element) {
      for (var i = 0; i < $scope.elements.length; i++) {
        if ($scope.elements[i] == element) {
          $scope.elements[i].visible = true;
          if(element == $scope.print) {
            pggPrintProvider.refreshTablak();
          }
        } else {
          $scope.elements[i].visible = false;
        }
      }
      pggInteractionsProvider.deactivateAll();
    };
  }
]);
